<template>
    <component :is="tagName" v-bind="attrs()" :class="classNames">
        <IdeoDropdown
            v-if="loaded"
            ref="dropdownRef"
            class="list-view-buttons"
            variant="secondary"
            :text="$t('[[[Akcje]]]')"
            dropleft
            boundary="body"
            no-flip
            no-caret
            @show="onShow"
            @hide="onHide"
        >
            <template #button-content>
                <i :class="icon" />
            </template>
            <slot name="default" />
        </IdeoDropdown>
        <Placeholder v-else :width="37" :height="32" />
    </component>
</template>

<script lang="ts" setup>
export interface Props
{
    icon?: string;
}

defineOptions({
    name: 'ListViewButtons',
    inheritAttrs: false
});

withDefaults(defineProps<Props>(), {
    icon: 'fa-regular fa-ellipsis-vertical'
});

const emit = defineEmits<{
    (e: 'show', item: any): void;
    (e: 'hide', item: any): void;
}>();

const dropdownRef = ref<any>(null);

provide('dropdownRef', dropdownRef);

const item = inject<ComputedRef<any>>('item');
const loaded = inject<Ref<boolean>>('loaded');
const layout = inject<Ref<string>>('layout');

const table = computed(() => layout.value == 'table');
const tagName = computed(() => table.value ? 'td' : 'div');
const classNames = computed(() => table.value ? 'actions-column text-end' : '');

const $attrs = useAttrs();
const attrs = (): Record<string, any> => only($attrs, 'class', 'style');

function onShow()
{
    emit('show', item.value);
}

function onHide()
{
    emit('hide', item.value);
}
</script>
